import React, { Suspense } from 'react';
import BasePage from './BasePage';
import ErrorBoundary from './hoc/ErrorBoundary';
import useComponentWillMount from './utility-functions/useComponentWillMount';

const App = React.lazy(() => import('./App'));

const Shell = () => {
  useComponentWillMount(() => {
    const body = document.querySelector('body');
    const theme = localStorage.getItem('theme') || 'Light';
    if (theme === 'Dark') {
      body.classList.add('theme-dark');
    } else {
      body.classList.add('theme-light');
    }
  });

  return (
    <ErrorBoundary>
      <Suspense fallback={<BasePage />}>
        <App />
      </Suspense>
    </ErrorBoundary>
  );
};

export default Shell;
